import { isAxiosError } from 'axios';
import { inject, injectable } from 'inversify';
import WalletService from 'src/features/pariWallet/data/service/WalletService';
import { GetWalletTransactionsParams } from 'src/features/pariWallet/data/service/WalletService.types';
import { GetWalletTransactionsUseCaseInterface } from 'src/features/pariWallet/domain/WalletUseCases.types';

@injectable()
class GetWalletTransactionsUseCase
  implements GetWalletTransactionsUseCaseInterface
{
  @inject(WalletService) private walletService!: WalletService;

  async execute({
    userUuid,
    ordering,
    filters,
    walletUuid,
    limit,
    offset,
  }: GetWalletTransactionsParams) {
    try {
      const response = await this.walletService.getWalletTransactions({
        userUuid,
        ordering,
        filters,
        walletUuid,
        limit,
        offset,
      });

      return response.data;
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 404) {
        return {
          count: 0,
          next: null,
          previous: null,
          results: [],
        };
      }
      throw error;
    }
  }
}

export default GetWalletTransactionsUseCase;
